<template>
    <text-input
        v-model="proxyModelValue"
        ref="addressInput"
        placeholder="Street Address"
        :error="error"
    />
</template>

<script>
import TextInput from './TextInput'
import { find, get, isEmpty, has } from 'lodash'

export default {
    props: {
        type: {
            type: String,
            default: 'geocode',
            validator: (value) => {
                return ['geocode', 'address', '(regions)'].includes(value)
            }
        },
        modelValue: String,
        error: String
    },
    emits: ['update:modelValue', 'update:address'],
    computed: {
        proxyModelValue: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },
    mounted() {
        const googleMapsScript = document.createElement('script')
        googleMapsScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${process.env.MIX_GOOGLE_API_KEY}&libraries=places`)
        googleMapsScript.addEventListener('load', () => {

            const autocomplete = new google.maps.places.Autocomplete(this.$refs.addressInput.$refs.input, {
                componentRestrictions: { country: ["us", "ca"] },
                fields: ["address_components"],
                types: [this.type],
            });

            autocomplete.addListener("place_changed", (e) => {
                const place = autocomplete.getPlace()

                if(!has(place, 'address_components')) return

                let street_1 = null

                const street_number = get(find(place.address_components, {types: ['street_number']}), 'short_name')
                const route = get(find(place.address_components, {types: ['route']}), 'short_name')

                if(street_number && route) {
                    street_1 = `${street_number} ${route}`
                }

                const address = {
                    street_1: street_1,
                    city: get(find(place.address_components, {types: ['locality']}), 'short_name'),
                    state: get(find(place.address_components, {types: ['administrative_area_level_1']}), 'short_name'),
                    postal_code: get(find(place.address_components, {types: ['postal_code']}), 'short_name'),
                    country: get(find(place.address_components, {types: ['country']}), 'short_name')
                }

                this.$emit('update:address', address)
            });
        })
        document.head.appendChild(googleMapsScript)
    },
    components: {
        TextInput,
    }
}
</script>
